export default "__VITE_ASSET__BMHsu$pq__"